import type { ReactNode } from 'react'
import React, { memo } from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'
import { useMediaQueryContext } from '@fourthwall/components'

import type { Mode, OfferItem, SingleVariantOfferItem } from '../../SelectProductsModal.types'
import { OpacityWrapper, ProductInfo } from '../ProductsListItem/ProductsListItem.styled'
import { ProductsListItemStatus } from '../ProductsListItemStatus/ProductsListItemStatus'
import * as S from './ProductsListItemOfferContent.styled'

type OfferItemContentProps = {
  item: OfferItem | SingleVariantOfferItem
  input: ReactNode
  mode: Mode
}

export const ProductsListItemOfferContent = memo(({ item, input, mode }: OfferItemContentProps) => {
  const media = useMediaQueryContext()

  return (
    <>
      <OpacityWrapper>{input}</OpacityWrapper>
      <OpacityWrapper>
        <PhotoThumbnail
          type={item.thumbnailType}
          url={item.image}
          size={media.tablet ? 'large' : 'small'}
        />
      </OpacityWrapper>
      <ProductInfo>
        <OpacityWrapper>{item.name}</OpacityWrapper>
        <S.Status>{!media.tablet && <ProductsListItemStatus item={item} mode={mode} />}</S.Status>
      </ProductInfo>
      {media.tablet && <ProductsListItemStatus item={item} mode={mode} />}
    </>
  )
})
